import { Link } from "react-router-dom";

const ProblemSection = () => (
  <section className="py-14 md:py-16 lg:py-20">
    <div className="mx-auto max-w-[1344px] px-5 md:px-8">
      <div className="editorial-grid">
        <div className="col-span-4 md:col-span-3 lg:col-span-4">
          <p className="eyebrow">Le vrai coût d'un appel manqué</p>
          <h2 className="mt-5 text-4xl font-semibold tracking-[-.035em] md:text-5xl lg:text-[56px] lg:leading-[1.02]">Un numéro seul ne dit rien.</h2>
        </div>
        <div className="col-span-4 mt-9 md:col-start-5 md:mt-0 lg:col-span-7 lg:col-start-5">
          <p className="max-w-[680px] text-[17px] leading-7 text-foreground/65">
            Entre deux visites, une estimation, un dossier locatif et un appel fournisseur se ressemblent tous : un numéro à rappeler. Immovox vous rend le contexte avant que vous repreniez la main.
          </p>
          <div className="mt-7 border-t border-foreground/20">
            {[["Vendeur potentiel","Bien, secteur, motif de vente, délai"],["Acquéreur","Recherche, budget, financement, timing"],["Candidat locataire","Situation, revenus, garant, date d'entrée"]].map(([a,b],i) => (
              <div key={a} className="grid grid-cols-[36px_1fr] gap-4 border-b border-border py-5 md:grid-cols-[50px_1fr_1.4fr]">
                <span className="font-mono text-[10px] text-primary">0{i+1}</span>
                <b className="text-[15px]">{a}</b>
                <span className="col-start-2 text-[14px] text-muted-foreground md:col-start-auto">{b}</span>
              </div>
            ))}
          </div>
          <Link to="/standard-telephonique-immobilier" className="mt-6 inline-block text-sm font-semibold text-primary">
            Comprendre le standard téléphonique immobilier →
          </Link>
        </div>
      </div>
    </div>
  </section>
);
export default ProblemSection;